module.exports = __webpack_public_path__ + "img/level_12_blackgold.c5dc0ff1.svg";